export const birthdays = [
  {
    name: "Lakshan Rukantha",
    birthMonth: 2,
    birthDate: 26,
  },
  {
    name: "Jeruxcy Almeda",
    birthMonth: 9,
    birthDate: 3,
  },
  {
    name: "Ruasha",
    birthMonth: 5,
    birthDate: 15,
  },
  {
    name: "Chamika Supun",
    birthMonth: 11,
    birthDate: 24,
  },
  {
    name: "Senuki Perera",
    birthMonth: 3,
    birthDate: 8,
  },
  {
    name: "Panchayu Bhanu Mihisara",
    birthMonth: 4,
    birthDate: 1,
  },
  {
    name: "Lakshitha Charaka",
    birthMonth: 11,
    birthDate: 28,
  },
  {
    name: "Akila Udantha",
    birthMonth: 3,
    birthDate: 26,
  },
  {
    name: "Radhishan Senanayaka",
    birthMonth: 12,
    birthDate: 17,
  },
  {
    name: "Themiya Kasun",
    birthMonth: 9,
    birthDate: 4,
  },
  {
    name: "Janethra Bandara",
    birthMonth: 11,
    birthDate: 2,
  },
  {
    name: "Dasun Kavinda",
    birthMonth: 10,
    birthDate: 20,
  },
  {
    name: "Duleesha Jayangani",
    birthMonth: 8,
    birthDate: 18,
  },
  {
    name: "Dilanjalee",
    birthMonth: 4,
    birthDate: 24,
  },
  {
    name: "Roshara Chandali",
    birthMonth: 9,
    birthDate: 30,
  },
  {
    name: "Sandun Sandeepa",
    birthMonth: 9,
    birthDate: 2,
  },
  {
    name: "Thilakshana Dilshan",
    birthMonth: 10,
    birthDate: 4,
  },
  {
    name: "Sapna Dilupshi",
    birthMonth: 8,
    birthDate: 14,
  },
  {
    name: "Dinesh Hashan",
    birthMonth: 6,
    birthDate: 16,
  },
  {
    name: "Nimeshi Dilshara",
    birthMonth: 7,
    birthDate: 24,
  },
  {
    name: "Dilshani Nawodya Mawarala Vitharana",
    birthMonth: 6,
    birthDate: 7,
  },
  {
    name: "Sadini Nimsara",
    birthMonth: 8,
    birthDate: 19,
  },
  {
    name: "Ashani Madushika",
    birthMonth: 4,
    birthDate: 9,
  },
  {
    name: "Dulara Pramod",
    birthMonth: 1,
    birthDate: 19,
  },
  {
    name: "Yasintha Chamikara",
    birthMonth: 9,
    birthDate: 6,
  },
  {
    name: "Imesh Naveen",
    birthMonth: 5,
    birthDate: 23,
  },
  {
    name: "Tharindi",
    birthMonth: 7,
    birthDate: 6,
  },
  {
    name: "Supuni",
    birthMonth: 10,
    birthDate: 27,
  },
  {
    name: "Nipun",
    birthMonth: 11,
    birthDate: 29,
  },
  {
    name: "Ravindu Ranasinghe",
    birthMonth: 1,
    birthDate: 27,
  },
  {
    name: "Udith Kavishan",
    birthMonth: 3,
    birthDate: 28,
  },
  {
    name: "Praveen Pasindu Kekulandala",
    birthMonth: 7,
    birthDate: 8,
  },
  {
    name: "Kaveesha Waduge",
    birthMonth: 5,
    birthDate: 31,
  },
  {
    name: "Hirushi Shashikala Rathnayaka",
    birthMonth: 7,
    birthDate: 12,
  },
  {
    name: "Nisal Mayuranga Perera",
    birthMonth: 7,
    birthDate: 17,
  },
  {
    name: "Madushanka Janitha",
    birthMonth: 5,
    birthDate: 2,
  },
  {
    name: "Randil Gimantha",
    birthMonth: 11,
    birthDate: 23,
  },
  {
    name: "M.A. Ashen Ruvinda",
    birthMonth: 2,
    birthDate: 5,
  },
  {
    name: "Isira Wickramasinghe",
    birthMonth: 7,
    birthDate: 29,
  },
  {
    name: "Sonal Sandeepa",
    birthMonth: 1,
    birthDate: 8,
  },
  {
    name: "H.G. Sandun Dinesh",
    birthMonth: 7,
    birthDate: 11,
  },
  {
    name: "Dewmini Navodya",
    birthMonth: 1,
    birthDate: 9,
  },
  {
    name: "Riekiee",
    birthMonth: 1,
    birthDate: 28,
  },
  {
    name: "Isuru Udara",
    birthMonth: 7,
    birthDate: 11,
  },
  {
    name: "Thanuji Dilanka",
    birthMonth: 8,
    birthDate: 11,
  },
  {
    name: "Fazla Fiyas",
    birthMonth: 12,
    birthDate: 20,
  },
  {
    name: "Amashani Dilhara",
    birthMonth: 8,
    birthDate: 28,
  },
  {
    name: "M. Sandaru Tharaka Pathirana",
    birthMonth: 6,
    birthDate: 9,
  },
  {
    name: "Kaweera Madushan",
    birthMonth: 12,
    birthDate: 25,
  },
  {
    name: "Shehan Sanjula",
    birthMonth: 5,
    birthDate: 17,
  },
  {
    name: "Manusha Hashen lowe",
    birthMonth: 12,
    birthDate: 23,
  },
  {
    name: "Oshan Yasintha",
    birthMonth: 3,
    birthDate: 22,
  },
  {
    name: "Pasith Nishshanka",
    birthMonth: 7,
    birthDate: 18,
  },
  {
    name: "Rasan Samarakkody",
    birthMonth: 2,
    birthDate: 5,
  },
  {
    name: "Bhasura Manodya",
    birthMonth: 7,
    birthDate: 28,
  },
  {
    name: "Thilina",
    birthMonth: 6,
    birthDate: 24,
  },
  {
    name: "Sandith kariyawasam",
    birthMonth: 7,
    birthDate: 25,
  },
  {
    name: "Musny Mubarak",
    birthMonth: 8,
    birthDate: 26,
  },
  {
    name: "Mohamed Naveeth",
    birthMonth: 11,
    birthDate: 11,
  },
  {
    name: "Susinidu Sachinthana",
    birthMonth: 4,
    birthDate: 17,
  },
  {
    name: "Malith Chinthaka Ramanayaka",
    birthMonth: 11,
    birthDate: 9,
  },
  {
    name: "Dushan Madushanka",
    birthMonth: 12,
    birthDate: 30,
  },
  {
    name: "Pathum Theekshana",
    birthMonth: 9,
    birthDate: 27,
  },
  {
    name: "Geshan Sampath",
    birthMonth: 9,
    birthDate: 2,
  },
  {
    name: "Tharindu Prabodha",
    birthMonth: 8,
    birthDate: 25,
  },
  {
    name: "Rasil Laksika",
    birthMonth: 4,
    birthDate: 24,
  },
  {
    name: "Dasun Bandara",
    birthMonth: 10,
    birthDate: 20,
  },
  {
    name: "Akshaya Kannan",
    birthMonth: 9,
    birthDate: 18,
  },
  {
    name: "Sandun Prabath",
    birthMonth: 9,
    birthDate: 14,
  },
  {
    name: "Kavindu Methmal",
    birthMonth: 10,
    birthDate: 19,
  },
  {
    name: "Hiran Ranasinghe",
    birthMonth: 6,
    birthDate: 12,
  },
  {
    name: "Nimshara P.G.R",
    birthMonth: 1,
    birthDate: 29,
  },
  {
    name: "Sachini Ruvindya",
    birthMonth: 8,
    birthDate: 28,
  },
  {
    name: "Binod Perera",
    birthMonth: 8,
    birthDate: 10,
  },
  {
    name: "Dewindi Prabodya",
    birthMonth: 12,
    birthDate: 22,
  },
  {
    name: "Githmi Senani",
    birthMonth: 9,
    birthDate: 13,
  },
  {
    name: "Mohamed Minhaaz",
    birthMonth: 9,
    birthDate: 22,
  },
  {
    name: "Chamith Harshamal",
    birthMonth: 2,
    birthDate: 15,
  },
  {
    name: "Ravindu Pahan",
    birthMonth: 11,
    birthDate: 13,
  },
  {
    name: "Anush Manujaya",
    birthMonth: 1,
    birthDate: 2,
  },
  {
    name: "Rakindu Athukorala",
    birthMonth: 11,
    birthDate: 20,
  },
  {
    name: "Dasharatha Bhanu",
    birthMonth: 10,
    birthDate: 30,
  },
];
